import { FILTER_INTERVENTION } from '../../../../constants';

const namespace = 'ui-search-filter-intervention';

export { FILTER_INTERVENTION, namespace };
